export default __webpack_public_path__ + "static/media/cancel-circle.4143ae56.svg";